// 专业课学长学姐借口
import ajax from '@/utils/ajax';

const header = '/web';
// 学长学姐列表
export const reqSeniorList = (data) =>
  ajax(`${header}/v1/senior/page-list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&pgCollege=${data.pgCollege}&pgSubject=${data.pgSubject}`);
// 学长学姐详情
export const reqSeniorDetail = (data) => ajax(`${header}/v1/senior/get/${data}`);

// 学校列表
export const reqSchoolList = (name, pageNum, pageSize) =>
  ajax(`${header}/v1/senior/match/college?name=${name}&pageNum=${pageNum}&pageSize=${pageSize}`);

// 学长学姐页面--搜索专业
export const reqMajorMath = (name) =>
  ajax(`${header}/v1/senior/match/subject?name=${name}`);
